import React, { useEffect, useRef, useState } from 'react';

export const CustomCursor = () => {
    const dotRef = useRef(null);
    const ringRef = useRef(null);
    const position = useRef({ x: -100, y: -100 });
    const ringPos = useRef({ x: -100, y: -100 });
    const [hovering, setHovering] = useState(false);
    const [isTouchDevice, setIsTouchDevice] = useState(false);

    useEffect(() => {
        const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
        if (touch) { setIsTouchDevice(true); return; }
        const handleMouseMove = (e) => { position.current = { x: e.clientX, y: e.clientY }; };
        const handleMouseOver = (e) => {
            const t = e.target;
            if (t.tagName === 'A' || t.tagName === 'BUTTON' || t.closest('a') || t.closest('button') || t.tagName === 'INPUT' || t.tagName === 'SELECT' || t.tagName === 'TEXTAREA') setHovering(true);
        };
        const handleMouseOut = (e) => {
            const t = e.target;
            if (t.tagName === 'A' || t.tagName === 'BUTTON' || t.closest('a') || t.closest('button') || t.tagName === 'INPUT' || t.tagName === 'SELECT' || t.tagName === 'TEXTAREA') setHovering(false);
        };
        const handleMouseLeave = () => { position.current = { x: -100, y: -100 }; ringPos.current = { x: -100, y: -100 }; };
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseover', handleMouseOver);
        document.addEventListener('mouseout', handleMouseOut);
        document.addEventListener('mouseleave', handleMouseLeave);
        let animId;
        const animate = () => {
            ringPos.current.x += (position.current.x - ringPos.current.x) * 0.15;
            ringPos.current.y += (position.current.y - ringPos.current.y) * 0.15;
            if (dotRef.current) dotRef.current.style.transform = `translate(${position.current.x - 6}px, ${position.current.y - 6}px)`;
            if (ringRef.current) {
                ringRef.current.style.transform = `translate(${ringPos.current.x - 20}px, ${ringPos.current.y - 20}px)`;
                ringRef.current.style.width = hovering ? '60px' : '40px';
                ringRef.current.style.height = hovering ? '60px' : '40px';
                ringRef.current.style.opacity = hovering ? '0.8' : '0.4';
                ringRef.current.style.marginLeft = hovering ? '-10px' : '0px';
                ringRef.current.style.marginTop = hovering ? '-10px' : '0px';
            }
            animId = requestAnimationFrame(animate);
        };
        animId = requestAnimationFrame(animate);
        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseover', handleMouseOver);
            document.removeEventListener('mouseout', handleMouseOut);
            document.removeEventListener('mouseleave', handleMouseLeave);
            cancelAnimationFrame(animId);
        };
    }, [hovering]);

    if (isTouchDevice) return null;
    return (
        <>
            <div ref={dotRef} className="cursor-dot" style={{ willChange: 'transform' }} />
            <div ref={ringRef} className="cursor-ring" style={{ willChange: 'transform', transition: 'width 0.2s ease, height 0.2s ease, opacity 0.2s ease' }} />
        </>
    );
};
